exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ref-hotkey{display:flex;align-items:center;justify-content:center;min-height:32px;border-bottom:1px solid #000}.ref-hotkey .title{width:50%;text-align:right;padding-right:16px;font-weight:bold;color:#72ca7e}.ref-hotkey .value{width:50%;text-align:left;padding-left:16px}.ref-hotkey:nth-child(odd){background-color:#101012}", ""]);

